import React, { useState } from 'react'
import { FormControl, FormHelperText, InputLabel } from '@material-ui/core'
import ReactQuill, { UnprivilegedEditor } from 'react-quill'
// eslint-disable-next-line prettier/prettier
import type Delta from 'quill-delta'

import { useStyles } from './styles'
import 'react-quill/dist/quill.bubble.css'

const TOOLBAR_OPTIONS = ['bold']

interface EditorInputProps {
  value?: string
  label?: string
  required?: boolean
  readOnly?: boolean
  maxLength?: number
  errorText?: string
  onChange?: (changes: string) => void
}

const EditorInput: React.FC<EditorInputProps> = ({
  value: initialValue = '',
  maxLength = -1,
  errorText = '',
  label,
  required,
  readOnly,
  onChange,
}) => {
  const classes = useStyles()

  const [value, setValue] = useState<string>(initialValue)
  const [hasErrors, setHasErrors] = useState(false)

  const handleEditorContentChange = (
    content: string,
    delta: Delta,
    source: string,
    editor: UnprivilegedEditor,
  ) => {
    setValue(content)

    if (onChange) onChange(content)

    const currentTextLength = editor.getText().trim().length
    setHasErrors(maxLength > 0 && currentTextLength > maxLength)
  }

  return (
    <FormControl fullWidth>
      {label && (
        <InputLabel required={required} shrink error={hasErrors}>
          {label}
        </InputLabel>
      )}
      <ReactQuill
        modules={{ toolbar: TOOLBAR_OPTIONS }}
        theme="bubble"
        value={value}
        onChange={handleEditorContentChange}
        readOnly={readOnly}
        className={classes.quillEditor + (hasErrors ? ` ${classes.error}` : '')}
      />
      {hasErrors && errorText && <FormHelperText error>{errorText}</FormHelperText>}
    </FormControl>
  )
}

EditorInput.defaultProps = {
  value: '',
  label: '',
  required: false,
  readOnly: false,
  maxLength: -1,
  errorText: '',
  onChange: undefined,
}

export { EditorInput }
